var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcaseicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7.92386C1 6.36582 2.26304 5.10278 3.82108 5.10278H20.1789C21.737 5.10278 23 6.36582 23 7.92386V9.98426C22.5765 10.1974 22.0974 10.4007 21.5663 10.5907C19.3814 11.3723 16.4144 11.8936 13.0913 11.9882V11.0953C13.0913 10.7213 12.7881 10.4182 12.4142 10.4182H11.4791C11.1052 10.4182 10.802 10.7213 10.802 11.0953V11.9852C7.52016 11.8829 4.59141 11.3643 2.42889 10.5907C1.89982 10.4014 1.42234 10.1989 1 9.9867V7.92386ZM1 11.2347V19.338C1 20.2728 1.75782 21.0306 2.69265 21.0306H21.3074C22.2422 21.0306 23 20.2728 23 19.338V11.2325C22.6674 11.3809 22.3153 11.5212 21.9463 11.6532C19.6186 12.4859 16.518 13.0223 13.0913 13.1171V14.0348C13.0913 14.4088 12.7881 14.7119 12.4142 14.7119H11.4791C11.1052 14.7119 10.802 14.4088 10.802 14.0348V13.1141C7.41578 13.0117 4.35344 12.4776 2.04881 11.6532C1.68162 11.5218 1.3312 11.3822 1 11.2347Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8016 5.10319V2.84632C16.8016 2.37891 16.4227 2 15.9553 2H8.03993C7.57252 2 7.1936 2.37891 7.1936 2.84632V5.10319",
    stroke: "currentColor",
    strokeWidth: 1.41054
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseicon);
export default __webpack_public_path__ + "static/media/briefcase.icon.a2808a012ec44fc6cc706fba1b03e5bc.svg";
export { ForwardRef as ReactComponent };